import { colors } from '../../colors';
var pencilBanner = {
  bgColor: colors.white,
  textColor: colors.deepOrange,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default pencilBanner;